const getIsChangeActivitiesLoading = (state) => {
  return state.isChangeActivitiesLoading;
};

export { getIsChangeActivitiesLoading };
